import { IPeriod } from '@mais-retorno-front/libs/util-models';
import { AxiosInstance } from 'axios';

export class GetBenchmarkStatsUseCase {
  constructor(
    private readonly url: string,
    private readonly http: AxiosInstance
  ) {}

  public async execute(benchmark: string, period?: IPeriod): Promise<any> {
    try {
      const { data } = await this.http.get(`${this.url}/${benchmark}/details`, {
        params: {
          start_date: period?.startDate,
          end_date: period?.endDate,
        },
      });

      return data;
    } catch {
      return {};
    }
  }
}
